export const templateRouteDef = [
    {
        path: 'template-builder',
        component: 'TemplateBuilderComponent',
        data: {
            selector: 'app-template-builder',
        }
    },
    {
        path: 'assessment-template',
        component: 'AssessmentTemplateComponent',
        data: {
            selector: 'app-assessment-template',
        }
    },
    {
        path: 'assessment',
        component:'AssessmentEngineComponent',
        data: {
            selector: 'app-assessment-engine'
        }
    },
    {
        path: ':id/:resource/templateView',
        component: 'ViewTemplateComponent',
        data: {
            selector: 'app-view-template'
        }
    },
    {
        path: ':id/:resource/feedBack',
        component: 'FeedbackFormComponent',
        data: {
            selector: 'app-feedback-form'
        }
    }
]